<template>
  <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
    <v-card-text>
      <v-container grid-list-md style="min-width: 100%;" class="pa-0">
        <v-layout row wrap>
          <v-flex xs12 md6>
            <v-text-field
              class="text-field-reducido-border"
              v-model="form.fecha_inicio"
              :rules="$validate(['required'])"
              required
              label="Fecha de incorporación"
              type="date"
              outline
            >
            </v-text-field>
          </v-flex>
          <v-flex xs12 md6>
            <v-autocomplete
              class="text-field-reducido-border"
              v-model.number="form.id_item"
              :items="items"
              item-text="nro_item"
              :item-value="val => parseInt(val.id)"
              :rules="$validate(['required'])"
              outline
              auto-select-first
              label="Item"
              disabled
            />
          </v-flex>
          <v-flex xs12 md6>
            <v-autocomplete
              class="text-field-reducido-border"
              v-model="form.id_cargo"
              :items="cargos"
              item-text="denominacion"
              :item-value="val => parseInt(val.id)"
              label="Seleccione Cargo"
              outline
              disabled
            ></v-autocomplete>
          </v-flex>
          <v-flex xs12 md6>
            <v-autocomplete
              class="text-field-reducido-border"
              v-model="form.id_puesto"
              :items="puestos"
              item-text="denominacion"
              :item-value="val => parseInt(val.id)"
              label="Seleccione Puesto"
              :rules="$validate(['required'])"
              outline
              disabled
            ></v-autocomplete>
          </v-flex>
          <v-flex xs12 md6>
            <v-autocomplete
              class="text-field-reducido-border"
              :items="unidades"
              item-text="nombre_unidad"
              :item-value="val => parseInt(val.id)"
              label="Unidad"
              v-model="form.id_unidad"
              outline
              :rules="$validate(['required'])"
            >
            </v-autocomplete>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <small class="error--text text-required"
        >* Los campos son obligatorios *</small
      >
      <v-spacer></v-spacer>
      <v-btn @click="close()">
        <v-icon>cancel</v-icon> {{ $t("common.cancel") }}
      </v-btn>
      <v-btn
        v-show="!fecha_futuro"
        color="primary"
        type="submit"
        :disabled="!valid"
        :loading="loading"
      >
        <v-icon dark>check</v-icon> {{ $t("common.save") }}
      </v-btn>
    </v-card-actions>
  </v-form>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  mixins: [validate],
  props: ["id_tipo_justificacion", "movilidad"],
  data() {
    return {
      id_persona: parseInt(this.$route.params.id),
      user: this.$storage.get("user"),
      valid: false,
      loading: false,
      form: {},
      nueva_asignacion: true,
      fecha_futuro: false,
      bandera_fecha: false,
      puestos: [],
      cargos: [],
      unidades: [],
      items: []
    };
  },
  async mounted() {
    this.unidades = await this.$query.select(
      "unidad",
      { id_estado: 17, id_entidad: 35 },
      ["id", "nombre_unidad"]
    );

    console.log('this.unidades....',this.unidades);

    this.items = await this.$query.select(
      "item", 
      { nro_item: "0" }, 
      ["id",  "nro_item" ]
    );
    console.log('this.items....',this.items);


    this.cargos = await this.$query.select(
      "cargo",
      { denominacion: "Pasante" },
      ["id", "denominacion"]
    );
    console.log('this.cargos....',this.cargos);

    this.puestos = await this.$query.select(
      "puesto",
      { denominacion: "Pasante" },
      ["id", "denominacion"]
    );
    console.log('this.puestos....',this.puestos);

    // Cargamos form
    this.form = {
      id_item: parseInt(this.items[0].id),
      id_puesto: parseInt(this.puestos[0].id),
      id_cargo: parseInt(this.cargos[0].id)
    };
    // Preguntamos si se esta editando

    if (!!this.movilidad.id) {
      this.form = {
        id_item: this.movilidad.id_item,
        id_puesto: this.movilidad.id_puesto,
        id_cargo: this.movilidad.id_cargo,
        id_unidad: this.movilidad.id_unidad,
        fecha_inicio: this.$moment(
          this.movilidad.fecha_desde,
          "DD/MM/YYYY"
        ).format("YYYY-MM-DD")
      };
    }
  },
  methods: {
    async save() {
      if (!this.$refs.form.validate()) {
        return;
      }
      let data_movilidad = {
        id_item: this.form.id_item,
        id_puesto: this.form.id_puesto,
        id_cargo: this.form.id_cargo,
        id_tipo_justificacion: this.id_tipo_justificacion,
        fecha_inicio: this.form.fecha_inicio,
        id_persona: this.id_persona,
        id_unidad: this.form.id_unidad,
        id_usuario: this.user.id
      };
      if (!!this.movilidad.id) {
        data_movilidad.id_movilidad = this.movilidad.id;
      } else {
        data_movilidad.id_movilidad = null;
      }
      try {
        if (this.$refs.form.validate()) {
          this.loading = true;
          let res = await this.$service.graphql({
            query: `
                query{
                  runQuery(consulta: "SELECT movilidad.fn_crea_edita_movilidad_pasante('${JSON.stringify(
                    data_movilidad
                  ).replace(/"/g, '\\"')}')"){
                    respuesta
                  }
                }
              `
          });
          let resp = res.runQuery.respuesta[0].fn_crea_edita_movilidad_pasante;
          let resps = resp.split("|");
          let correcto = resps[0];
          if (correcto === "1") {
            this.$message.success();
            this.close();
          } else {
            this.$message.error(resps[1]);
          }
          this.loading = false;
        }
      } catch (error) {
        console.log(error);
      }
    },

    close() {
      this.form = {};
      this.loading = false;
      this.valid = false;
      this.$bus.$emit("closeDialogNuevaMovilidadPasante");
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/movilidad/components/IncorporacionPasante.vue